<template>
  <div class="p-12">
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500 capitalize">Πακέτα Προϊόντων</h4>
          <RouterLink
            :to="{ name: 'admin.products.packages.create' }"
            class="btn btn-brand style-inverted px-6 capitalize"
          >
            Νέο Πακέτο
          </RouterLink>
        </div>

        <div class="flex -mx-4">
          <div class="w-64 px-4">
            <SidebarFilters :disabled="loading" />
          </div>
          <div class="flex-1 px-4">
            <BaseAdvancedList
              searchable
              :loading="loading"
              :with-list-header="listHeader"
              :with-list-item="listItem"
              :entities="products"
              :meta="meta"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import ListHeader from '@/components/Package/ListHeader.vue';
import ListItem from '@/components/Products/PackageListItem.vue';
import SidebarFilters from '@/components/Products/SidebarFilters.vue';

export default {
  name: 'PackagesView',
  components: {
    SidebarFilters,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState('admin/products', ['meta']),
    ...mapGetters('admin/products', ['products']),
    listHeader() {
      return ListHeader;
    },
    listItem() {
      return ListItem;
    },
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.clear();
  },
  methods: {
    ...mapActions('admin/products', ['fetchPackageList']),
    ...mapMutations('admin/products', ['setIds', 'setMeta', 'setLinks']),
    clear() {
      this.setIds([]);
      this.setMeta(null);
      this.setLinks(null);
    },
    async fetchData() {
      const { query: params } = this.$route;
      const include = 'media';
      this.clear();
      this.loading = true;
      try {
        await this.fetchPackageList({ params: { ...params, include } });
      } catch (error) {
        //
      }
      this.loading = false;
    },
  },
};
</script>
